<div class="p-grid dashboard">
	<div class="p-col-12 p-md-6 p-lg-3">
		<div class="overview-box  box-sales">
			<div class="overview-box-icon">
				<i class="pi pi-dollar"></i>
			</div>
			<div class="overview-box-title">T.B.D</div>
			<div class="overview-box-value">T.B.D</div>
			<div class="overview-box-status">T.B.D</div>
		</div>
	</div>

	<div class="p-col-12 p-md-6 p-lg-3">
		<div class="overview-box  box-views">
			<div class="overview-box-icon">
				<i class="pi pi-search"></i>
			</div>
			<div class="overview-box-title">T.B.D</div>
			<div class="overview-box-value">T.B.D</div>
			<div class="overview-box-status">T.B.D</div>
		</div>
	</div>

	<div class="p-col-12 p-md-6 p-lg-3">
		<div class="overview-box  box-users">
			<div class="overview-box-icon">
				<i class="pi pi-user"></i>
			</div>
			<div class="overview-box-title">T.B.D</div>
			<div class="overview-box-value">T.B.D</div>
			<div class="overview-box-status">T.B.D</div>
		</div>
	</div>

	<div class="p-col-12 p-md-6 p-lg-3">
		<div class="overview-box  box-checkins">
			<div class="overview-box-icon">
				<i class="pi pi-map-marker"></i>
			</div>
			<div class="overview-box-title">T.B.D</div>
			<div class="overview-box-value">T.B.D</div>
			<div class="overview-box-status">T.B.D</div>
		</div>
	</div>


	<div class="p-col-12 p-lg-8">
		<div class="card chart">
			<h1 style="margin-top:0">Quarter Reports</h1>
			<p-chart type="line" [data]="chartData" [options]="chartOptions"></p-chart>
		</div>
	</div>

	<div class="p-col-12 p-lg-4">
		<div class="card chat">
			<h1 style="margin-top:0">Chat</h1>
			<ul>
				<li class="message-from">
					<div class="p-grid">
						<div class="p-col-fixed">
							<img src="assets/layout/images/avatar/avatar-kate.jpg" alt="prestige-layout"/>
						</div>
						<div class="p-col">
							<div class="chat-profile-info">
								<span class="chat-profile">Kate</span>
								<span class="chat-profile-job">Managment</span>
							</div>
							<div class="chat-message">Hey Yeniffer And Micheal, I heard there is a task
								about unexpected event occured near San Mateo recently. Can you guys handle
								today?
							</div>
							<div class="message-time">
								22 mins ago
							</div>
						</div>
					</div>
				</li>
				<li class="message-to">
					<div class="p-grid">
						<div class="p-col-fixed">
							<img src="assets/layout/images/avatar/avatar-yeniffer.jpg"
								 alt="prestige-layout"/>
						</div>
						<div class="p-col">
							<div class="chat-profile-info">
								<span class="chat-profile">Yeniffer</span>
								<span class="chat-profile-job">Development</span>
							</div>
							<div class="chat-message">I’m busy today but we can work on it on Sunday
								afternoon. Does that sounds good for you Micheal?
							</div>
							<div class="message-time">
								12 mins ago
							</div>
						</div>
					</div>
				</li>
				<li class="message-from">
					<div class="p-grid">
						<div class="p-col-fixed">
							<img src="assets/layout/images/avatar/avatar-micheal.jpg"
								 alt="prestige-layout"/>
						</div>
						<div class="p-col">
							<div class="chat-profile-info">
								<span class="chat-profile">Micheal</span>
								<span class="chat-profile-job">Design</span>
							</div>
							<div class="chat-message">Sounds good for me.</div>
							<div class="message-time">
								2 mins ago
							</div>
						</div>
					</div>
				</li>
				<li class="message-to">
					<div class="p-grid">
						<div class="p-col-fixed">
							<img src="assets/layout/images/avatar/avatar-yeniffer.jpg"
								 alt="prestige-layout"/>
						</div>
						<div class="p-col">
							<div class="chat-profile-info">
								<span class="chat-profile">Yeniffer</span>
								<span class="chat-profile-job">Development</span>
							</div>
							<div class="chat-message">Great! See you on Sunday. Don't forget the bring coffee :)</div>
							<div class="message-time">
								12 mins ago
							</div>
						</div>
					</div>
				</li>
			</ul>
			<div class="new-message">
				<div class="p-grid p-nogutter">
					<div class="p-col">
						<input placeholder="Write your message.."/>
					</div>
					<div class="p-col-fixed">
						<button><i class="pi pi-paperclip"></i></button>
						<button><i class="pi pi-upload"></i></button>
						<button><i class="pi pi-save"></i></button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card tasks">
			<h1 style="margin-top:0">Tasks</h1>
			<ul>
				<li>
					<p-checkbox binary="true"></p-checkbox>
					<span>Sales Reports</span>
					<span class="task-badge-open">Open<i class="pi pi-circle-on"></i></span>
				</li>
				<li>
					<p-checkbox binary="true"></p-checkbox>
					<span>Pay Invoices</span>
					<span class="task-badge-open">Open<i class="pi pi-circle-on"></i></span>
				</li>
				<li>
					<p-checkbox binary="true"></p-checkbox>
					<span>Birthday Party</span>
					<span class="task-badge-open">Open<i class="pi pi-circle-on"></i></span>
				</li>
				<li>
					<p-checkbox binary="true"></p-checkbox>
					<span>Client Meeting</span>
					<span class="task-badge-closed">Closed<i class="pi pi-circle-on"></i></span>
				</li>
				<li>
					<p-checkbox binary="true"></p-checkbox>
					<span>New Themes</span>
					<span class="task-badge-closed">Closed<i class="pi pi-circle-on"></i></span>
				</li>
				<li>
					<p-checkbox binary="true"></p-checkbox>
					<span>Flight Ticket</span>
					<span class="task-badge-closed">Closed<i class="pi pi-circle-on"></i></span>
				</li>
			</ul>
		</div>
	</div>

	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card resolution-center">
			<h1 style="margin-top:0">Resolution Center</h1>
			<div class="ui-inputgroup">
				<span class="ui-inputgroup-addon"><i class="pi pi-user"></i></span>
				<input type="text" pInputText placeholder="Name">
			</div>

			<div class="ui-inputgroup">
				<span class="ui-inputgroup-addon"><i class="pi pi-envelope"></i></span>
				<input type="text" pInputText placeholder="E-Mail">
			</div>

			<textarea type="text" [rows]="9" [autoResize]="false" pInputTextarea placeholder="Your Message"></textarea>

			<div class="resolution-button-bar">
				<button type="button" label="Send Message" pButton></button>
				<a>View old messages</a>
			</div>
		</div>
	</div>

	<div class="p-col-12 p-lg-4">
		<div class="card team">
			<h1 style="margin-top:0">Team Members</h1>
			<ul>
				<li>
					<img src="assets/layout/images/avatar/avatar-pedro.jpg" alt="prestige-layout"/>
					<div class="team-box">
                                    <span class="team-member">
                                        <div class="team-member-status"></div>Pedro Anorim
                                    </span>
						<span class="team-member-job">Development</span>
					</div>
					<button type="button" label="Add" pButton></button>
				</li>
				<li>
					<img src="assets/layout/images/avatar/avatar-daisy.jpg" alt="prestige-layout"/>
					<div class="team-box">
                                    <span class="team-member">
                                        <div class="team-member-status"></div>Daisy Murphy
                                    </span>
						<span class="team-member-job">Design</span>
					</div>
					<button type="button" label="Add" pButton></button>
				</li>
				<li>
					<img src="assets/layout/images/avatar/avatar-mbah.jpg" alt="prestige-layout"/>
					<div class="team-box">
                                    <span class="team-member">
                                        <div class="team-member-status"></div>Mbah ENow
                                    </span>
						<span class="team-member-job">Management</span>
					</div>
					<button type="button" label="Add" pButton></button>
				</li>
				<li>
					<img src="assets/layout/images/avatar/avatar-qin.jpg" alt="prestige-layout"/>
					<div class="team-box">
                                    <span class="team-member">
                                        <div class="team-member-status"></div>Qin Shi
                                    </span>
						<span class="team-member-job">Management</span>
					</div>
					<button type="button" label="Add" pButton></button>
				</li>
			</ul>
			<div class="all-members-link">
				<a>See all team members</a>
			</div>
		</div>
	</div>
</div>
